import { isFirstDayOfMonth, isLastDayOfMonth, isBefore, isAfter, isWithinInterval } from 'date-fns';
import isSameDay from 'date-fns/isSameDay';

const getSelectedClassName = (date, selectedDay, options = {}) => {
    let className = null;
    const { hoveredDate, isStart, hasSelection, startAndEndDaySame, noEndDate } = options;
    const isSelected = selectedDay && isSameDay(date, selectedDay);
    if (isSelected) {
        className = 'selectedDay withRightBorder withLeftBorder ';
        className += isStart ? 'leftRounded' : 'rightRounded';
        if (isStart && !noEndDate) {
            const isHoveredBeforeOrSame = !!hoveredDate && (isBefore(hoveredDate, selectedDay) || isSameDay(hoveredDate, selectedDay));
            if (startAndEndDaySame || (!hasSelection && (isHoveredBeforeOrSame || !hoveredDate))) {
                className += ' rightRounded';
            }
        }
    }
    return className;
};
const getHoverdClassName = (date, [start, end], hoveredDate) => {
    const isHoveredDate = !!hoveredDate && isSameDay(date, hoveredDate);
    if (isHoveredDate) {
        const hasNoSelection = !start && !end;
        if (hasNoSelection) {
            return 'rightRounded leftRounded';
        }
        const hasOnlyStart = !!start && !end;
        if (hasOnlyStart) {
            const isAfterStart = !!start && isAfter(date, start);
            return isAfterStart ? 'rightRounded' : 'rightRounded leftRounded';
        }
        const hasSelection = !!start && !!end;
        if (hasSelection) {
            const isNotWithinRange = !isWithinInterval(date, { start, end });
            if (isNotWithinRange) {
                return 'rightRounded leftRounded';
            }
        }
    }
};
const getNoEndClassName = (date, start) => {
    const isAfterStart = !!start && isAfter(date, start);
    let className = '';
    if (isAfterStart) {
        className = 'react-datepicker__day--in-range ';
    }
    if (isFirstDayOfMonth(date)) {
        className += 'leftRounded';
    }
    if (isLastDayOfMonth(date)) {
        className += 'rightRounded';
    }
    return className;
};
const getDaysClassName = (date, range, hoveredDate, noEndDate) => {
    const [start, end] = range;
    const hasSelection = !!start && !!end;
    const startAndEndDaySame = hasSelection && isSameDay(start, end);
    const startDayRangeClassName = getSelectedClassName(date, start, {
        hoveredDate,
        isStart: true,
        hasSelection,
        startAndEndDaySame,
        noEndDate,
    });
    if (startDayRangeClassName) {
        return startDayRangeClassName;
    }
    const endDayRangeClassName = getSelectedClassName(date, end);
    if (endDayRangeClassName && !noEndDate) {
        return endDayRangeClassName;
    }
    if (noEndDate) {
        return getNoEndClassName(date, start);
    }
    const hoverdClassName = getHoverdClassName(date, range, hoveredDate);
    if (hoverdClassName) {
        return hoverdClassName;
    }
    if (isFirstDayOfMonth(date)) {
        return 'leftRounded';
    }
    if (isLastDayOfMonth(date)) {
        return 'rightRounded';
    }
    return null;
};

export { getDaysClassName };
//# sourceMappingURL=getDaysClassName.js.map
